import React, { useState, useEffect, useRef } from 'react';
import { Button, Card, Form, Row, Col, Alert, Spinner } from 'react-bootstrap';
import { fetchGetData, fetchPostData, fetchFormData } from './api'; // Import your common API file

const TrackEmployee = () => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [companyName, setCompanyName] = useState('206723');
    const [jobRole, setJobRole] = useState('1');
    const [noOfCandidates, setNoOfCandidates] = useState('5');
    const [gender, setGender] = useState('0');
    const [maritalStatus, setMaritalStatus] = useState('NULL');
    const [salary, setSalary] = useState('20000');
    const [age, setAge] = useState('25');
    const [experience, setExperience] = useState('2');
    const [qualification, setQualification] = useState('High School');
    const [mobile, setMobile] = useState('9842701007');
    const [address, setAddress] = useState('Testing');
    const [district, setDistrict] = useState('14');
    const [selectedArea, setSelectedArea] = useState('562');
    const [districts, setDistricts] = useState([]);
    const [jobRoles, setJobRoles] = useState([]);
    const [jobEmployer, setEmployer] = useState([]);
    const [areas, setAreas] = useState([]);

    // Fetch data on component mount
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [districtRes, jobRoleRes, jobEmployer] = await Promise.all([
                    fetchGetData('/master/get/district/city'), // Replace with actual API
                    fetchGetData('/master/get/title'),    // Replace with actual API
                    fetchGetData('/master/get/employer')    // Replace with actual API
                ]);
                setDistricts(districtRes.data);
                setJobRoles(jobRoleRes.data);
                setEmployer(jobEmployer.data);
            } catch (error) {
                console.error('Error fetching data:', error);
                setErrorMessage('Error loading district and job role data.');
            }
        };

        fetchData();
    }, []);

    const handleDistrictChange = (e) => {
        const selectedDistrictId = e.target.value;
        setDistrict(selectedDistrictId);
        setAreas(''); // Reset selected area

        // Find the selected district from the districts array
        const selectedDistrict = districts.find(d => d.id === Number(selectedDistrictId));

        // If district is found, set its areas
        if (selectedDistrict) {
            setAreas(selectedDistrict.areas); // Set areas from the selected district
        } else {
            setAreas([]); // Reset areas if no district is selected
        }
    };

    const validateForm = () => {
        if (!noOfCandidates.trim()) return "Name is required.";
        if (!mobile.trim()) return "Mobile number is required.";
        if (!/^[6789][0-9]{9}$/.test(mobile)) return "Mobile number must be exactly 10 digits and start with 6, 7, 8, or 9.";
        if (!district) return "District must be selected.";
        if (!jobRole) return "Job role must be selected.";
        if (!selectedArea) return "Area must be selected.";
        if (!qualification) return "Qualification is required.";
        if (!gender) return "Gender must be selected.";
        if (!maritalStatus) return "marital status must be selected.";
        return null;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationError = validateForm();
        if (validationError) {
            setErrorMessage(validationError);
            return;
        }

        // Create a new FormData object and append all form fields to it
        const formData = new FormData();
        formData.append('companyName', companyName);
        formData.append('jobRole', jobRole);
        formData.append('noOfCandidates', noOfCandidates);
        formData.append('gender', gender);
        formData.append('mobile', mobile);
        formData.append('district', district);
        formData.append('selectedArea', selectedArea);
        formData.append('qualification', qualification);
        formData.append('experience', experience);
        formData.append('maritalStatus', maritalStatus);

        setLoading(true);

        try {
            const response = await fetchPostData('/employer/create', formData, {
                'Content-Type': 'application/json',
            });

            if (response.success) {
                setSuccessMessage('Form submitted and processed successfully!');
                // setCompanyName('');
                // setJobRole('');
                // setNoOfCandidates('');
                // setGender('');
                // setMaritalStatus('');
                // setSalary('');
                // setAge('');
                // setExperience('');
                // setQualification('');
                // setMobile('');
                // setAddress('');
                // setDistrict('');
                // setSelectedArea('');

                setCompanyName('206723');
                setJobRole('1');
                setNoOfCandidates('5');
                setGender('0');
                setMaritalStatus('NULL');
                setSalary('20000');
                setAge('25');
                setExperience('2');
                setQualification('High School');
                setMobile('9842701007');
                setAddress('Testing');
                setDistrict('14');
                setSelectedArea('562');
            } else {
                setErrorMessage('Form submission failed.');
            }
        } catch (error) {
            console.error('Error submitting the form:', error);
            // setErrorMessage('An error occurred while submitting the form.');
            setErrorMessage(JSON.stringify(error.message));
        } finally {
            setLoading(false);
        }

        setTimeout(() => {
            setErrorMessage(''); // Clear error message
            setSuccessMessage(''); // Clear success message
        }, 5000);
    };

    return (
        <div className="container mt-5">
            <Card className="p-4 shadow-sm">
                <h4 className="mb-4">Create employer vacancy</h4>
                {loading && (
                    <div className="text-center my-4">
                        <Spinner animation="border" />
                    </div>
                )}
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="companyName">
                                <Form.Label>Choose employer</Form.Label>
                                <Form.Select
                                    value={companyName}
                                    onChange={(e) => setCompanyName(e.target.value)}
                                    required
                                >
                                    <option value="">Choose employer</option>
                                    {jobEmployer.map(role => (
                                        <option key={role.id} value={role.id}>
                                            {role.english}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="jobRole">
                                <Form.Label>Job Role</Form.Label>
                                <Form.Select
                                    value={jobRole}
                                    onChange={(e) => setJobRole(e.target.value)}
                                    required
                                >
                                    <option value="">Select Job Role</option>
                                    {jobRoles.map(role => (
                                        <option key={role.id} value={role.id}>
                                            {role.english}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="noOfCandidates">
                                <Form.Label>No of candidates</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={noOfCandidates}
                                    onChange={(e) => setNoOfCandidates(e.target.value)}
                                    minLength={1}
                                    maxLength={3}
                                    required
                                    placeholder="Enter no of candidates"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="gender">
                                <Form.Label>Gender</Form.Label>
                                <div>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="male"
                                        name="gender"
                                        label="Male"
                                        value="0"
                                        checked={gender === '0'}
                                        onChange={(e) => setGender(e.target.value)}
                                        required
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="female"
                                        name="gender"
                                        label="Female"
                                        value="1"
                                        checked={gender === '1'}
                                        onChange={(e) => setGender(e.target.value)}
                                        required
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="other"
                                        name="gender"
                                        label="None"
                                        value="NULL"
                                        checked={gender === 'NULL'}
                                        onChange={(e) => setGender(e.target.value)}
                                        required
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="maritalStatus">
                                <Form.Label>Marital status</Form.Label>
                                <div>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="Unmarried"
                                        name="maritalStatus"
                                        label="Unmarried"
                                        value="0"
                                        checked={maritalStatus === '0'}
                                        onChange={(e) => setMaritalStatus(e.target.value)}
                                        required
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="Married"
                                        name="maritalStatus"
                                        label="Married"
                                        value="1"
                                        checked={maritalStatus === '1'}
                                        onChange={(e) => setMaritalStatus(e.target.value)}
                                        required
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="ed allowed"
                                        name="maritalStatus"
                                        label="Both Married and Unmarried allowed"
                                        value="NULL"
                                        checked={maritalStatus === 'NULL'}
                                        onChange={(e) => setMaritalStatus(e.target.value)}
                                        required
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="salary">
                                <Form.Label>Salary</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={salary}
                                    onChange={(e) => setSalary(e.target.value)}
                                    // pattern="^[6789][0-9]{9}$"
                                    pattern="^(10000|[1-8][0-9]{4}|9[0-8][0-9]{3}|99000)$"
                                    title="Salary must be between 10000 and 99000"
                                    required
                                    placeholder="Enter salary"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="age">
                                <Form.Label>Age</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={age}
                                    onChange={(e) => setAge(e.target.value)}
                                    pattern="^(1[89]|[2-7][0-9]|80)$"
                                    title="Age must be between 18 and 80"
                                    required
                                    placeholder="Enter age"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="experience">
                                <Form.Label>Experience</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={experience}
                                    onChange={(e) => setExperience(e.target.value)}
                                    pattern="^(0|[1-9]|1[0-9]|2[0-5])$"
                                    title="Experience must be between 0 and 25"
                                    required
                                    placeholder="Enter experience"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="qualification">
                                <Form.Label>Qualification</Form.Label>
                                <Form.Select
                                    value={qualification}
                                    onChange={(e) => setQualification(e.target.value)}
                                    required
                                >
                                    <option value="">Select Qualification</option>
                                    <option value="High School">High School</option>
                                    <option value="Bachelor's">Bachelor's</option>
                                    <option value="Master's">Master's</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="mobile">
                                <Form.Label>Mobile</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)}
                                    pattern="^[6789][0-9]{9}$"
                                    required
                                    placeholder="Enter mobile number"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="mobile">
                                <Form.Label>Address</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3} // Number of rows for the textarea
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    required
                                    placeholder="Enter company/job address"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="district">
                                <Form.Label>Candidate apply district</Form.Label>
                                <Form.Select
                                    value={district}
                                    onChange={handleDistrictChange}
                                    required
                                >
                                    <option value="">Select District</option>
                                    {districts.map(district => (
                                        <option key={district.id} value={district.id}>
                                            {district.dist}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="area">
                                <Form.Label>Candidate apply location</Form.Label>
                                <Form.Select
                                    value={selectedArea}
                                    onChange={(e) => setSelectedArea(e.target.value)}
                                    required
                                >
                                    <option value="">Select Area</option>
                                    {areas.map(area => (
                                        <option key={area.id} value={area.id}>
                                            {area.area_name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="text-center">
                        <Button type="submit" variant="primary" disabled={loading}>
                            {loading ? 'Submitting...' : 'Submit'}
                        </Button>
                    </div>
                </Form>
                {errorMessage && (
                    <Alert variant="danger" className="mt-3">
                        {errorMessage}
                    </Alert>
                )}
                {successMessage && (
                    <Alert variant="success" className="mt-3">
                        {successMessage}
                    </Alert>
                )}
            </Card>
        </div>
    );
};

export default TrackEmployee;
